class ESGHighlights {
    constructor() {
        this.container = document.querySelector('.c-section.cc-esg_highlights_slider');
        if (!this.container) return;

        this.slider = this.container.querySelector('.c-highlights_cont');
        this.slides = this.container.querySelectorAll('.c-highlight');
        this.prevBtn = this.container.querySelector('.e-slider_btn.cc-prev');
        this.nextBtn = this.container.querySelector('.e-slider_btn.cc-next');
        this.currentIndex = 0;
        this.currentPosition = 0;

        this.init();
        this.updateButtonStates();

        // Add aria-live region for screen readers
        this.slider.setAttribute('aria-live', 'polite');
        
        // Add aria-controls and aria-current
        this.slides.forEach((slide, index) => {
            slide.setAttribute('aria-hidden', 'false');
            slide.id = `highlight-${index}`;
        });

        this.updateAriaAttributes();
        this.setupKeyboardNavigation();
    }

    init() {
        this.prevBtn.addEventListener('click', () => this.handlePrev());
        this.nextBtn.addEventListener('click', () => this.handleNext());
    }

    updateButtonStates() {
        if (this.currentIndex >= this.slides.length - 1) {
            this.nextBtn.classList.add('inactive');
        } else {
            this.nextBtn.classList.remove('inactive');
        }

        if (this.currentIndex <= 0) {
            this.prevBtn.classList.add('inactive');
        } else {
            this.prevBtn.classList.remove('inactive');
        }
    }

    updateAriaAttributes() {
        // Update aria-hidden states
        this.slides.forEach((slide, index) => {
            slide.setAttribute('aria-hidden', index !== this.currentIndex ? 'true' : 'false');
        });

        // Update button states
        this.prevBtn.setAttribute('aria-disabled', this.currentIndex <= 0);
        this.nextBtn.setAttribute('aria-disabled', this.currentIndex >= this.slides.length - 1);
        
        // Announce current slide (optional)
        const currentSlide = this.slides[this.currentIndex];
        const year = currentSlide.querySelector('.cc-year').textContent;
        const description = currentSlide.querySelector('.cc-description').textContent;
        this.slider.setAttribute('aria-label', `Slide ${this.currentIndex + 1} of ${this.slides.length}: ${year} - ${description}`);
    }

    setupKeyboardNavigation() {
        this.container.addEventListener('keydown', (e) => {
            switch(e.key) {
                case 'ArrowLeft':
                    e.preventDefault();
                    this.handlePrev();
                    break;
                case 'ArrowRight':
                    e.preventDefault();
                    this.handleNext();
                    break;
                case 'Home':
                    e.preventDefault();
                    // Logic to go to first slide
                    break;
                case 'End':
                    e.preventDefault();
                    // Logic to go to last slide
                    break;
            }
        });
    }

    handleNext() {
        if (this.currentIndex >= this.slides.length - 1) return;

        const slideWidth = this.slides[0].offsetWidth;
        const slideToAnimate = this.slides[this.currentIndex]; // Animate current slide
        const accentDot = slideToAnimate.querySelector('.e-slider_accent.cc-dot');
        const accentLineLeft = slideToAnimate.querySelector('.e-slider_accent.cc-line_left');
        const accentLineBottom = slideToAnimate.querySelector('.e-slider_accent.cc-line_bottom');
        const textYear = slideToAnimate.querySelectorAll('.e-text.cc-year');
        const textDescription = slideToAnimate.querySelectorAll('.e-text.cc-description');
        
        const timeline = gsap.timeline();
        
        timeline.to(accentDot, {
            opacity: 0,
            duration: 0.3,
            ease: 'power2.inOut'
        })
        .to(textDescription, {
            y: 20,
            opacity: 0,
            duration: 0.5,
            ease: 'power2.inOut'
        }, '<')
        .to(textYear, {
            y: 10,
            opacity: 0,
            duration: 0.3,
            stagger: {
                amount: 0.3,
                from: "end"
            },
            ease: 'power2.inOut',
        }, '-=50%')
        .to(accentLineLeft, {
            height: 0,
            duration: 0.3,
            ease: 'power2.inOut'
        }, '-=20%')
        .to(accentLineBottom, {
            width: 0,
            duration: 0.3,
            ease: 'power2.inOut'
        }, '<')
        
        
        .to(this.slider, {
            x: this.currentPosition - slideWidth,
            duration: 0.5,
            ease: 'power2.inOut'
        });

        this.currentPosition -= slideWidth;
        this.currentIndex++;
        this.updateButtonStates();
        this.updateAriaAttributes();
    }

    handlePrev() {
        if (this.currentIndex <= 0) return;

        const slideWidth = this.slides[0].offsetWidth;
        const slideToAnimate = this.slides[this.currentIndex - 1]; // Animate previous slide
        const accentDot = slideToAnimate.querySelector('.e-slider_accent.cc-dot');
        const accentLineLeft = slideToAnimate.querySelector('.e-slider_accent.cc-line_left');
        const accentLineBottom = slideToAnimate.querySelector('.e-slider_accent.cc-line_bottom');
        const textYear = slideToAnimate.querySelectorAll('.e-text.cc-year');
        const textDescription = slideToAnimate.querySelectorAll('.e-text.cc-description');

        // get css variables offset and dot width
        const accentDotOffset = getComputedStyle(accentDot).getPropertyValue('--vertical-offset');
        const accentDotWidth = getComputedStyle(accentDot).getPropertyValue('--accent-dot-width');
        
        const timeline = gsap.timeline();
        
        timeline.to(this.slider, {
            x: this.currentPosition + slideWidth,
            duration: 0.5,
            ease: 'power2.inOut'
        })
        .to(accentLineLeft, {
            height: `calc(100% - ${accentDotOffset} - ${accentDotWidth})`,
            duration: 0.3,
            ease: 'power2.inOut'
        })
        .to(accentLineBottom, {
            width: '100%',
            duration: 0.3,
            ease: 'power2.inOut'
        }, '<')
        .to(accentDot, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.inOut'
        })
        .to(textYear, {
            y: 0,
            opacity: 1,
            duration: 0.3,
            stagger: {
                amount: 0.3,
                from: "end"
            },
            ease: 'power2.inOut',
        }, '<')
        .to(textDescription, {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: 'power2.inOut'
        }, '-=20%');

        this.currentPosition += slideWidth;
        this.currentIndex--;
        this.updateButtonStates();
        this.updateAriaAttributes();
    }
}

export default ESGHighlights;
